// @ts-nocheck
import { Column } from 'react-table'
import { TitleCell } from './TitleCell'
import { UserCustomHeader } from './CustomHeader'
import moment from 'moment';
import { ActionCell } from './ActionCell'


const notificationListColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Description' className='min-w-50px' />
    ),
    id: 'description',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.message} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Created At' className='min-w-50px' />
    ),
    id: 'createdAt',
    Cell: ({ ...props }) => <TitleCell userObj={moment(props.data[props.row.index]?.createdAt).format("YYYY-MM-DD")} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Action' className='min-w-75px' />
    ),
    id: 'action',
    Cell: ({ ...props }) => <ActionCell user={props.data[props.row.index]} />,
  },
]

export { notificationListColumns }
